module.exports = __webpack_public_path__ + "static/media/avatar2.81990da8.png";